<template>
  <div>
    <div style="font-size: 1.25rem" class="px-4 font-weight-bold mt-4">
      {{ $vuetify.lang.t("$vuetify.ai_response.image_search") }}
    </div>
    <v-card-text>
      {{ $vuetify.lang.t("$vuetify.ai_response.set_input_field_txt") }}
    </v-card-text>
    <v-form ref="recommend_form" class="ml-4">
      <v-row>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="text" v-model="user_id" :label='$vuetify.lang.t("$vuetify.ai_response.user_id")' dense outlined :rules="[
            required(
              $vuetify.lang.t('$vuetify.ai_response.user_id')
            ),
          ]">
          </v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-btn class="mr-4 primary--text" outlined @click="generateUserUUID">
            {{ $vuetify.lang.t("$vuetify.ai_response.autogenerate") }}
          </v-btn>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="text" v-model="member_id" :label='$vuetify.lang.t("$vuetify.ai_response.member_id")' dense outlined></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-btn class="mr-4 primary--text" outlined @click="generateMemberUUID">
            {{ $vuetify.lang.t("$vuetify.ai_response.autogenerate") }}
          </v-btn>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-file-input v-model="file" outlined dense :label="$vuetify.lang.t('$vuetify.ai_response.image')" prepend-icon="mdi-camera"
          @change="onFileSelected"
          :rules="[
            required($vuetify.lang.t('$vuetify.ai_response.image'))
          ]"
          ></v-file-input>
        </v-col>
        
        <v-col cols="6" md="6" xs="12"></v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="number" v-model="start" :label='$vuetify.lang.t("$vuetify.ai_response.start")' dense outlined
          :rules="startRules"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="number" v-model="size" :label='$vuetify.lang.t("$vuetify.ai_response.size")' dense outlined
          :rules="sizeRules"
          ></v-text-field>
        </v-col>
        <v-btn class="float-right ml-2" color="primary" @click="getRecommendedItems" dark>
          {{ $vuetify.lang.t("$vuetify.ai_response.get_response") }}
        </v-btn>
        <v-card-title>
        </v-card-title>

      </v-row>
    </v-form>
    <v-dialog v-model="openResponseModal" max-width="90%">
      <template v-if="responseLoading">
        <Loader class="mr-2 mt-6" />
      </template>
      <v-card v-else class="d-flex flex-column"
        style="overflow-y: scroll; overflow-x: hidden ; min-height: 80vh; position: relative;">
        <v-container>
          <div style="font-size: 1.25rem" class="font-weight-medium mt-8">
            {{ $vuetify.lang.t("$vuetify.ai_response.uploaded_image") }}
          </div>
        </v-container>
        <v-container>
          <v-row>
            <v-col  cols="12" md="3">
              <v-card class="product-card" outlined>
                <v-img v-if="imageUrl" :src="imageUrl" height="100px"></v-img>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-container>
          <div style="font-size: 1.25rem" class="font-weight-medium mt-8">
            {{ $vuetify.lang.t("$vuetify.ai_response.image_search_items") }}
          </div>
        </v-container>

        <v-container>
          <v-row v-if="recommendedItems && recommendedItems.length > 0">
            <v-col v-for="product in recommendedItems" :key="product[mapper.item_id]" cols="12" md="3">
              <v-card class="product-card" @click="copyItemToClipBoard(product)" outlined>
                <v-img :src="product[mapper.image_url]" height="100px">
                  <template #placeholder>
                      <div class="d-flex align-center justify-center grey--text text-caption" style="height: 100%">
                        {{ $vuetify.lang.t("$vuetify.ai_response.image_not_available") }}
                      </div>
                  </template>
                </v-img>
                <div class="card-content">
                  <p class="ml-4">{{ product[mapper.title].slice(0, 50) }}</p>
                  <strong class="ml-4">¥ {{ product[mapper.price] }}</strong>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-col v-else  class="d-flex align-items-center pa-0">
            <v-icon class="text-info mr-2">mdi-information</v-icon>
            <span class="text-body-1">
              {{ $vuetify.lang.t("$vuetify.ai_response.recommended_items_not_found") }}
            </span>
          </v-col>
        </v-container>
        <v-divider></v-divider>
        <v-card-title>
          <v-card-actions class="justify-end" style="position: absolute; bottom: 0; right: 0;">
            <v-btn color="primary" text @click="openResponseModal=false">
              {{ $vuetify.lang.t("$vuetify.ai_response.close") }}
            </v-btn>
          </v-card-actions>
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import { IMAGES_SEARCH, ADD_ALERT} from "@/store/_actiontypes";
import { mapState, mapActions } from "vuex";
import Loader from "@/components/common/loader/Loader";
export default {
  components: {
    Loader
  },
  props: {
    mapper: {
      type: Object,
    },
    catalogItems: {
      type: Array
    }
  },
  data() {
    return {
      user_id: "",
      member_id: "",
      item_id: "",
      openModal: false,
      openResponseModal: false,
      recommendedItems : [],
      responseLoading: false,
      searchText: "",
      price_lower: 0,
      start: 0,
      size: 10,
      price_upper: 20,
      categories: "",
      startRules: [
        value => value === "" || value >= 0 || `${this.$vuetify.lang.t("$vuetify.ai_response.min_value_error")} 0`,
      ],
      sizeRules: [
        value => value === "" || value >= 1 || `${this.$vuetify.lang.t("$vuetify.ai_response.min_value_error")} 1`,
      ],
      file: null,
      sort: {},
      imageUrl: null,
      priceRules: [
        value => value >= 1 || `${this.$vuetify.lang.t("$vuetify.ai_response.min_value_error")} 1`,
      ]

    };
  },
  computed: {
    ...mapState({
      selectedProject: (state) => state.project.selectedProject,
      user: (state) => state.account.user
    }),
  },
  methods: {
    ...mapActions("ai_response", [IMAGES_SEARCH]),
    ...mapActions("alert", [ADD_ALERT]),
    required(fieldName) {
      return (value) => !!value || `${fieldName} ${this.$vuetify.lang.t("$vuetify.ai_response.is_required")}`;
    },
    generateMemberUUID() {
      this.member_id = uuidv4()
    },
    generateUserUUID() {
      this.user_id = uuidv4()
    },
    copyItemToClipBoard(item){
      navigator.clipboard.writeText(JSON.stringify(item, null, 2));
      this.$store.dispatch(
                `alert/${ADD_ALERT}`, {
                  message: this.$vuetify.lang.t("$vuetify.ai_response.item_copied_message"),
                  color: "success",
                }, { root: true }
              );
    },
    setItemId(itemId){
      this.item_id = itemId
      this.openModal = false
    },
    getFormData(){
      return {
        member_id : this.member_id,
        user_id: this.user_id,
        item_id: this.item_id,

      }
    },
    onFileSelected(file) {
      
      if (file && file.type.startsWith('image/')) {
        this.imageUrl = URL.createObjectURL(file);
      } else {
        this.imageUrl = null;
      }
    },
    validateForm() {
      return this.$refs.recommend_form.validate();
    },
    getRecommendedItems(){
      const valid = this.validateForm()
      if(!valid) return
      this.openResponseModal = true
      this.responseLoading = true
      const optionalPayloads = {}
      if(this.start !== ""){
        optionalPayloads.start = Number.parseInt(this.start)
      }
      if(this.size !== ""){
        optionalPayloads.size = Number.parseInt(this.size)
      }

      this.IMAGES_SEARCH({
        project_id: this.selectedProject.id,
        user_id: this.user_id,
        member_id: this.member_id,
        image: this.file,
        ...optionalPayloads,
      }).then(
        (response) => {
          this.responseLoading = false
          this.recommendedItems = response.data.detail.response
        },
        (error) => {
          console.error("error", error)
          if(error.status === 422){
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: JSON.stringify(error?.response?.data?.detail),
                    color: "error",
                  }, { root: true }
                );
          } else {
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: error?.response?.data?.detail?.response,
                    color: "error",
                  }, { root: true }
            );
          }
          this.openResponseModal = false
        }
      );
    }
  }
};
</script>

<style scoped>
        .product-card {
          height: 300px; 
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          cursor: pointer;
        }
        .card-content {
          padding: 4px;
        }
    
        .card-content .v-card-title {
          margin-bottom: 0;
          font-size: 16px;
        }
    
        .card-content .v-card-subtitle {
          margin-bottom: 8px;
        }
</style>
